module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "header"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col"
  }, [_c('span', [(!_vm.readOnly) ? _c('a', {
    staticClass: "text-white",
    on: {
      "click": _vm.edit
    }
  }, [_c('i', {
    staticClass: "fa fa-pencil"
  })]) : _vm._e(), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.description))]), _vm._v(" "), _c('span', {
    staticStyle: {
      "padding-left": "8px"
    }
  }, [_vm._v(_vm._s(' | '))])]), _vm._v(" "), (!_vm.showCarbon) ? [_c('span', {
    staticClass: "badge"
  }, [_vm._v(_vm._s(_vm.dimensions))]), _vm._v("\n        " + _vm._s(' | ') + "\n        "), _c('span', {
    staticClass: "badge"
  }, [_vm._v(_vm._s(_vm.weight))])] : _c('span', {
    staticClass: "badge"
  }, [_vm._v(_vm._s(_vm.carbon))]), _vm._v(" "), (_vm.lot) ? [_c('span', [_vm._v(_vm._s(' | '))]), _vm._v(" "), _c('span', {
    staticClass: "badge"
  }, [_vm._v("Lot #:  " + _vm._s(_vm.lot))])] : _vm._e(), _vm._v(" "), (!_vm.readOnly) ? _c('div', {
    staticClass: "float-right"
  }, [_c('button', {
    staticClass: "close text-white",
    attrs: {
      "type": "button",
      "data-dismiss": "alert",
      "aria-label": "Close"
    },
    on: {
      "click": _vm.remove
    }
  }, [_c('span', {
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("×")])])]) : _vm._e()], 2)])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-430d1acc"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/shippinglvls/ShippingLvlHeader.vue
// module id = 702
// module chunks = 0